export enum InvoiceContextEnum {
    IS_PAID = "IS_PAID",
    TO_PAID = "TO_PAID",
    DD_PENDING = "DD_PENDING",
    DD_FAILED = "DD_FAILED"
}